const MIN_ORDER_QTY = 20;

const checkoutSelectors = [
  '#checkout',
  '#CartDrawer-Checkout',
  '#cart-notification-form button[name="checkout"]',
];

function getHasUnitCaseFromDOM() {
  return Array.from(document.querySelectorAll('[data-cart-has-unit-case]')).some(
    (element) => element.dataset.cartHasUnitCase === 'true'
  );
}

function setCheckoutButtonsDisabled(disabled) {
  checkoutSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((button) => {
      button.disabled = disabled;
    });
  });
}

function showMinimumWarningFallback() {
  document.querySelectorAll('[data-cart-min-qty-warning]').forEach((warning) => {
    warning.removeAttribute('hidden');
  });

  document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((container) => {
    container.style.display = 'none';
  });
}

function applyMinimumOrderQuantityUI(itemCount) {
  const hasUnitCase = getHasUnitCaseFromDOM();
  const belowMinimum = itemCount > 0 && itemCount < MIN_ORDER_QTY && !hasUnitCase;
  const isEmpty = itemCount === 0;

  checkoutSelectors.forEach((selector) => {
    document.querySelectorAll(selector).forEach((button) => {
      button.disabled = isEmpty || belowMinimum;
    });
  });

  document.querySelectorAll('[data-cart-min-qty-warning]').forEach((warning) => {
    warning.toggleAttribute('hidden', !belowMinimum);
  });

  document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach((container) => {
    container.style.display = belowMinimum ? 'none' : '';
  });
}

function updateMinimumOrderQuantityUI(itemCount) {
  const hasValidItemCount = Number.isFinite(itemCount);

  if (hasValidItemCount) {
    applyMinimumOrderQuantityUI(itemCount);
    return;
  }

  setCheckoutButtonsDisabled(true);

  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => applyMinimumOrderQuantityUI(cart.item_count))
    .catch(() => {
      setCheckoutButtonsDisabled(true);
      showMinimumWarningFallback();
    });
}
